import { Button, FiCheckCircle, Flex } from '@agrotoken-tech/ui';
import {
  CROP_PLEDGE_USER_ROLES,
  PLEDGE_SECTION_STATUSES,
  PledgeSectionStatus,
} from '@bcba/types';
import { useCropPledgeContext } from '../../CropPledgeDetail/context/CropPledgeContext';
import { useTranslation } from '@bcba/react-hooks';

interface Props {
  sectionStatus: PledgeSectionStatus;
  isFormDirty?: boolean;
  onRequestApproval?: () => void;
  isPendingRequestApproval?: boolean;
  onApprove?: () => void;
  isPendingApprove?: boolean;
}

const CropPledgeSectionActions = ({
  sectionStatus,
  isFormDirty = true,
  onRequestApproval,
  isPendingRequestApproval = false,
  onApprove,
  isPendingApprove = false,
}: Props) => {
  const { t } = useTranslation();
  const { isPledgeInAnEditableStage, role } = useCropPledgeContext();

  const showRequestApprovalButton =
    Boolean(onRequestApproval) &&
    isPledgeInAnEditableStage &&
    role === CROP_PLEDGE_USER_ROLES.DEBTOR &&
    (sectionStatus === PLEDGE_SECTION_STATUSES.PENDING_DEBTOR_LOAD ||
      sectionStatus === PLEDGE_SECTION_STATUSES.PENDING_BOLSA_LOAD ||
      sectionStatus === PLEDGE_SECTION_STATUSES.PENDING_BOLSA_APPROVAL);

  const isDisabledApprovalButton =
    !isFormDirty &&
    (sectionStatus === PLEDGE_SECTION_STATUSES.PENDING_BOLSA_LOAD ||
      sectionStatus === PLEDGE_SECTION_STATUSES.PENDING_BOLSA_APPROVAL);

  const showApproveButton =
    Boolean(onApprove) &&
    isPledgeInAnEditableStage &&
    role === CROP_PLEDGE_USER_ROLES.CREDITOR &&
    (sectionStatus === PLEDGE_SECTION_STATUSES.PENDING_CREDITOR_LOAD ||
      sectionStatus === PLEDGE_SECTION_STATUSES.PENDING_CREDITOR_APPROVAL);

  return (
    <Flex w="full" justifyContent={'flex-end'}>
      {showRequestApprovalButton && (
        <Button
          variant={'primary'}
          leftIcon={<FiCheckCircle />}
          onClick={onRequestApproval}
          isLoading={isPendingRequestApproval}
          isDisabled={isDisabledApprovalButton}
        >
          {t('common.requestApproval')}
        </Button>
      )}
      {showApproveButton && (
        <Button
          variant={'primary'}
          leftIcon={<FiCheckCircle />}
          onClick={onApprove}
          isLoading={isPendingApprove}
        >
          {t('common.approveChanges')}
        </Button>
      )}
    </Flex>
  );
};

export default CropPledgeSectionActions;
